module.exports = __webpack_public_path__ + "static/media/autopista.73fd928e.svg";